package er.prateek.crossly.progression

import er.prateek.crossly.data.model.GameMode
import er.prateek.crossly.firebase.AnalyticsEvents
import er.prateek.crossly.firebase.AnalyticsLogger

/**
 * Marks today's daily as done and logs what that did to the daily-puzzle streak. Every mode the
 * Daily can roll (word, math, riddles) goes through here, so the daily-streak funnel can't drift
 * between them or go silent for the newer modes.
 */
fun DailyPuzzleManager.recordCompletionAndLog(analytics: AnalyticsLogger, mode: GameMode) {
    val previous = currentStreak()
    val updated = recordCompletion()
    if (updated.currentStreak > previous.currentStreak) {
        analytics.logEvent(
            AnalyticsEvents.STREAK_EXTENDED,
            mapOf(
                "mode" to mode.analyticsName,
                "current_streak" to updated.currentStreak,
                "longest_streak" to updated.longestStreak,
                "is_new_longest" to (updated.currentStreak > previous.longestStreak),
            ),
        )
    } else if (updated.currentStreak == 1 && previous.currentStreak > 1) {
        // A gap was already missed before this play -- this is the completion that
        // surfaces/confirms it, not the moment the streak actually broke.
        analytics.logEvent(
            AnalyticsEvents.STREAK_BROKEN,
            mapOf(
                "mode" to mode.analyticsName,
                "previous_streak" to previous.currentStreak,
                "longest_streak" to previous.longestStreak,
            ),
        )
    }
}
